import { resolveUrl } from "../../../utils/url/urlResolver";

export interface NavigationTreeDataDTO {
  childTypes: {
    type: string;
    typeTranslation: string;
    position: number;
    enabled: boolean;
  }[];
  parentLabelTranslation: string;
  parentPosition: number;
  parentType: string;
  parentTypeTranslation: string;
  enabledParent: boolean;
}

export async function getNavigationTree(): Promise<NavigationTreeDataDTO[]> {
  const url = resolveUrl(`/notifications/navigation-tree`);

  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });

  const dto = (await response.json()) as NavigationTreeDataDTO[];

  dto[0].childTypes = [];

  return dto;
}
